<cec-dialog width="18rem" headerKey="CrewDetail" [subTitle]="crew?.crewNumber" [hideConfirmButton]="true">
  @if (crew) {
    <div class="title">{{ 'Driver' | translate }}:</div>
    <div class="competitor-row driver">
      <img
        src="{{ '../../../../../../../assets/' + crew.driverFlag }}"
        alt="flag"
        class="flag"
      />
      <div>{{ crew.driver }}</div>
    </div>
    <div class="title">{{ 'Navigator' | translate }}:</div>
    <div class="competitor-row">
      <img
        src="{{ '../../../../../../../assets/' + crew.navigatorFlag }}"
        alt="flag"
        class="flag"
      />
      <div>{{ crew.navigator }}</div>
    </div>
  }
</cec-dialog>